// 定义用户的登录、注册、注销、个人信息、操作等
import request from "@/lib/axios.js";
// import qs from 'qs'
// 用户登录操作
export function login(query) {
  return request({
    url: "/login/login",
    method: "post",
    data: query
  });
}

// 绑定第三方登录
export function bindUserByThirdLogin(query) {
  return request({
    url: "/login/bindUserByThirdLogin",
    method: "post",
    data: query
  });
}

// 退出登录
export function logout() {
  return request({
    url: "/login/loginOut",
    method: "post"
  });
}

// 获取个人信息
export function getUserDetail(query) {
  return request({
    url: "/user/getUserDetail",
    method: "post",
    data: query
  });
}

// 获取用户邀请二维码
export function GetInviteEwm() {
  return request({
    url: "/user/getInviteEwm",
    method: "post"
  });
}

// 获取用户邀请二维码
export function getUserPub() {
  return request({
    url: "/user/getUserPub",
    method: "post"
  });
}

// 获取供应商跟进员列表
export function findSupDftUser(id) {
  return request({
    url: "/user/findSupDftUserList",
    method: "post",
    data: { supplierId: id }
  });
}

// 获取供应商跟进员列表
export function findUserList(id) {
  return request({
    url: "/user/findUserList",
    method: "post",
    data: { memberId: id }
  });
}

// 签到
export function SignIn() {
  return request({
    url: "/user/signin",
    method: "post"
  });
}

// 获取企业等级信息
export function findCompanyLevel() {
  return request({
    method: "post",
    url: "/company/level/findCompanyLevel"
  });
}

// 获取用户积分信息
export function getUserIntegral() {
  return request({
    url: "/user/getUserIntegral",
    method: "post"
  });
}

// 获取第三方登录信息
export function getThirdLoginDetail() {
  return request({
    method: "POST",
    url: "/login/getThirdLoginDetail",
    data: {}
  });
}

// 查询第三方登录状态
export function checkThirdLoginStatus(query) {
  return request({
    method: "POST",
    url: "/login/checkThirdLoginStatus",
    data: query
  });
}

// 获取邀请用户信息
export function getInviteDetail(query) {
  return request({
    method: "POST",
    url: "/login/getInviteDetail",
    data: query
  });
}

// 用户注册
export function register(query) {
  return request({
    method: "POST",
    url: "/login/register",
    data: query
  });
}

// 用户注册验证（账号、手机号码、企业名称）
export function verifyRegister(query) {
  return request({
    method: "POST",
    url: "/login/verifyRegister",
    data: query
  });
}
// 忘记密码保存
export function forgetPasswordInOutside(query) {
  return request({
    method: "POST",
    url: "/user/forgetPasswordInOutside",
    data: query
  });
}
// 注册不通过/完善资料-获取用户信息
export function getUserDetailByRegister(query) {
  return request({
    method: "POST",
    url: "/login/getUserDetailByRegister",
    data: query
  });
}
// 角色新增保存
export function saveOrupdateSysRole(query) {
  return request({
    method: "POST",
    url: "/auth/sysRole/saveOrupdateSysRole",
    data: query
  });
}
// 角色列表
export function findSysRoleListByPage(query) {
  return request({
    method: "POST",
    url: "/auth/sysRole/findSysRoleListByPage",
    data: query
  });
}
// 保存角色配置的用户
export function saveConfUser(query) {
  return request({
    method: "POST",
    url: "/auth/sysRole/saveConfUser",
    data: query
  });
}
// 启用/禁用所选中的角色
export function enableOrDisable(query) {
  return request({
    method: "POST",
    url: "/auth/sysRole/enableOrDisable",
    data: query
  });
}
// 获取角色配置的用户
export function getConfUser(query) {
  return request({
    method: "POST",
    url: "/auth/sysRole/getConfUser",
    data: query
  });
}
// 获取配置资源
export function getConfResoure(query) {
  return request({
    method: "POST",
    url: "/auth/sysRole/getConfResoure",
    data: query
  });
}
// 保存角色配置资源
export function saveConfResoure(query) {
  return request({
    method: "POST",
    url: "/auth/sysRole/saveConfResoure",
    data: query
  });
}
// 账号设置-查找用户资料接口
export function findUserDetailById(query) {
  return request({
    method: "POST",
    url: "/user/findUserDetailById",
    data: query
  });
}
// 账号设置-新增修改子账号
export function addOrEditChildAccount(query) {
  return request({
    method: "POST",
    url: "/auth/user/addOrEditChildAccount",
    data: query
  });
}
// 账号设置-修改子账号密码
export function modifyPassword(query) {
  return request({
    method: "POST",
    url: "/auth/user/modifyPassword",
    data: query
  });
}
// 账号设置-查找该企业业务员角色
export function findSysUserRole(query) {
  return request({
    method: "POST",
    url: "/user/findSysUserRole",
    data: query
  });
}
// 商家中心-是否满足申请资格判断
export function isAchieveDeal(query) {
  return request({
    method: "POST",
    url: "/workOrder/isAchieveDeal",
    data: query
  });
}
// 快速注册
export function doQuickRegister(query) {
  return request({
    method: "POST",
    url: "/login/doQuickRegister",
    data: query
  });
}
